import {Component, OnInit} from '@angular/core';
import {UserDataService} from '../user-data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NgForm} from '@angular/forms';

@Component({
    selector: 'app-resend-activation-code',
    templateUrl: './resend-activation-code.component.html',
    styleUrls: ['./resend-activation-code.component.scss']
})
export class ResendActivationCodeComponent implements OnInit{

    // Server Response After Send
    serverResp = false;
    formHasBeenSend = false;
    formSuccessfulSend = false;
    serverErrorMessages: string;

    userEmail: string;


    constructor(private userDataService: UserDataService,
                private router: Router,
                private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.userDataService.getMainData()
            .subscribe(user => {
                if (user) {
                    this.router.navigate(['/cont']);
                }
            });
    }

    onSubmit(form: NgForm) {

        this.userEmail = form.value.userEmail;


        this.userDataService.resendRegistrationCode(this.userEmail).subscribe(resData => {
            this.serverResp = true;
            this.formHasBeenSend = true;
            this.formSuccessfulSend = true;

            if (resData['success']===false) {
                this.serverErrorMessages = "Ceva nu a functionat bine. Mai incearca o data."
                form.reset();
                this.serverResp = false;
                this.formSuccessfulSend = false;
            } else if (resData['success'] === true) {
                this.redirectUser();
            }

        }, error => {

            this.serverErrorMessages = "Ceva nu a functionat bine. Mai incearca o data."
            form.reset();
            this.serverResp = false;
            this.formHasBeenSend = true;
        });
    }

    // Redirect user after a few seconds
    redirectUser() {
        setTimeout(() => {
            this.router.navigate(['/autentificare']);
        }, 4000);
    }
}
